export enum CouponTypes {
  Basket = 'BASKET',
  SingleBasketPerUser = 'SINGLE_BASKET_PER_USER',
  Credit = 'CREDIT',
  Prize = 'PRIZE',
  FixedOdds = 'FIXED_ODDS',
  DreamHome = 'DREAMHOME',
  SubscriptionBasket = 'SUBSCRIPTION_BASKET',
  SingleSubscriptionBasketPerUser = 'SINGLE_SUBSCRIPTION_BASKET_PER_USER',
  SingleSubscriptionPerUser = 'SINGLE_SUBSCRIPTION_PER_USER',
  SingleSubscription = 'SINGLE_SUBSCRIPTION',
  SingleOrder = 'SINGLE_ORDER',
  SingleOrderPerUser = 'SINGLE_ORDER_PER_USER',
}

export enum CouponPrizeTarget {
  All = 'all',
  Prize = 'prize',
  FixedOdds = 'fixedOdds',
  DreamHome = 'raffle',
}

interface PrizeObject {
  title: string;
  _id: string;
  prizeCategory?: string;
  subCategory?: any;
}

export interface Coupon {
  _id?: string;
  type: string;
  title: string;
  batchTitle?: string;
  discountType?: string;
  startDate?: string;
  finishDate?: string;
  basketAmount?: number;
  fixedOddsTickets?: number;
  isActive: boolean;
  couponId: string;
  value: number;
  description: string;
  raffle?: PrizeObject | string | any;
  fixedOdds?: PrizeObject | string | any;
  prize?: PrizeObject | string | any;
  user?: string;
  dateOfUse?: string;
  maxTickets?: number;
  discountDurationMonths?: number;
  limit?: number;
}

export interface CouponBatch {
  _id?: string;
  type: string;
  title: string;
  couponId: string;
  limit: number;
  raffle?: PrizeObject | string | any;
  discountType?: string;
  startDate?: string;
  finishDate?: string;
  couponsQuantity: number;
  isActive: boolean;
  value: number;
  description: string;
  maxTickets?: number;
  discountDurationMonths?: number;
  basketAmount?: number;
}

export interface CouponBatchItem {
  _id?: string;
  isUsed: boolean,
  couponBatchId: string,
  couponId: string,
}

export interface WowcherCoupon {
  _id?: string;
  couponId: string;
  type: string;
  value: number;
  price: number;
  userEmail: string;
}